export function isTouchDevice() {
    const reactDeviceDetect = require("react-device-detect");
    if (reactDeviceDetect.deviceType !== "browser") {
        return true;
    }
    if (reactDeviceDetect.isTablet) {
        return true;
    }
    return false;
}

export function isMobile() {
    const reactDeviceDetect = require("react-device-detect");
    if (reactDeviceDetect.deviceType == "mobile") {
        return true;
    }
    return false;
}

